import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner, Card, Icon, Breadcrumb, Switcher, Tooltip } from "pepsico-ds";
import { Col, message, Row } from 'antd';
import MultiSelectDropdown from '../../components/Dropdown/MultiSelectDropdown';
import SingleSelectDropdown from '../../components/Dropdown/SingleSelectDropdown';
import reset_icon from "../../assets/reset_icon.svg";
import { useNavigate } from "react-router-dom";
import "./Commodity.scss"
import { FetchRISIDetailAction, FetchRISIDropdownAction, FetchRISISecondaryDropdownAction } from "../../redux/action/RISIAction";
import { getBUsForSupplierFilters, getSectorsForSupplierFilters, getYears, getSectors, getRoles, getBusinessUnitsBySector, getCommoditiesForRISI, getIndexesForRISI, getLocationsForRISI, changeToDateOptionsUtil, changeFromDateOptionsUtil } from "../KPIOverview/KpiUtils";
import { formatIntoDropdownData, getOverlappingOptionsV2, getMonthsAdjustedForCurrentDate, getCurrentMonthObject ,getToDateOptions, getMonthsWithYearWithMaxDate, getToDateOptionsWithMaxDate, getMonthsWithYearRangeAdjustedForMaxDate, getOverlappingOptions, returnHyphenIfNull, transformIndexData, getAdditionalDisplayTexts, getFirstUniqueItems, call7DaysNpsLogic } from '../../utils/utils';
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from '../../constants/localStoreKeys';
import InfoIcon from "../../components/Icons/InfoIcon";
import DropdownWithIcons from "../../components/Modal/DropdownWithIcons";
import { useToast } from "../../components/Toast/ToastContext";
import Vector from  '../../assets/Vector.png'


import CommonTable from '../../components/Table/CommonTable';
import RisiLineChart from '../../components/Charts/RISIChart/RisiLineChart'
import NoData from '../../components/NoData/NoData'
import LegendList from "../../components/Charts/Legend/LegendList";
import ActualRisiLegend from '../../assets/ActualRisiLegend.svg'
import ActualLegendRISI from '../../assets/ActualLegendRISI.svg'
import ForecastRisiLegend from '../../assets/ForecastRisiLegend.svg'
import CustomButtons from "../../components/Cards/CustomButtons";

const DEFAULT_RISI_L0 = [{id: 1, displayText: "GP DIRECTS"}]
const DEFAULT_RISI_L1 = [{id: 1, displayText: "PACKAGING"}]
const defaultYear = window.YEAR
const MAX_OPTIONS_SELECTION_ALLOWED = 5; 
const MIN_RISI_YEAR = 2023;
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const date = new Date();
const currentYear = date.getFullYear();
const DEFAULT_FROM_DATE_YEAR = currentYear-1;
const DEFAULT_TO_DATE_YEAR = currentYear+1;
const DEFAULT_FROM_DATE = "Jan "+DEFAULT_FROM_DATE_YEAR;
const DEFAULT_TO_DATE = "Dec "+DEFAULT_TO_DATE_YEAR;


function RISIScreen() {
    const navigate = useNavigate();
	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)
    const [dropdownValues, setDropdownValues] = useState({})
    const [secondaryDropdownValues, setSecondaryDropdownValues] = useState({})
    const [isDataLoading, setIsDataLoading] = useState(false);

    
    const [roleSelected, setRoleSelected] = useState([])
    const [sectors, setSectors] = useState([])
    const [sectorSelected, setSectorSelected] = useState([])
    const [userSectors, setUserSectors] = useState([])
    const [businessUnits, setBusinessUnits] = useState([])
    const [businessUnitSelected, setBusinessUnitSelected] = useState([])
    const [userBusinessUnits, setUserBusinessUnits] = useState([])
    const [allBUs, setAllBUs] = useState([])
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const [fromDates, setFromDates] = useState([])
    const [toDates, setToDates] = useState([])
    const [fromDateSelected, setFromDateSelected] = useState("")
    const [toDateSelected, setToDateSelected] = useState("")
    const [entireMonthList, setEntireMonthList] = useState([])


    const [commodities, setCommodities] = useState([])
    const [commoditySelected, setCommoditySelected] = useState([])
    const [indexes, setIndexes] = useState([])
    const [indexSelected, setIndexSelected] = useState([])
    const [locations, setLocations] = useState([])
    const [locationSelected, setLocationSelected] = useState([])
    const [currencies, setCurrencies] = useState([])
    const [currencySelected, setCurrencySelected] = useState([])
    const [firstRequest, setFirstRequest] = useState(true);
    const [indexMapping, setIndexMapping] = useState({});
    const [firstForecastYearMonth, setFirstForecastYearMonth] = useState('');
    const [firstForecastKeysToBeMergedActualLAst, setFirstForecastKeysToBeMergedActualLAst] = useState([]);
    const [lineChartactualData, setLineChartActualData] = useState([]);

    /**** PRASANNA CHANGES DECLARATIONS ****/

    const [switcherIndex, setSwitcherIndex] = useState(0)
    const [chartData, setChartData] = useState([]);
    const [forecastStartVal, setForecastStartVal] = useState('');
    const [risiSeriesLineChartIndex, setRisiSeriesLineChartIndex] = useState([]);
    const [risiLineChartLegends, setRisiLineChartLegends] = useState([]);
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
      

    let risiTableColumns = [
        { columnKey: 'commodityId', header: "Commodity ID", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'commodityDescription', header: "Commodity Description", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'indexId', header: "Index ID", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'indexDescription', header: "Index Description", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'risiLocation', header: "RISI Location", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'currency', header: "Currency", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'incoTerms', header: "INCO Terms", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'assessmentFrequency', header: "Assessment Frequency", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'latestPriceLow', header: "Latest Price (low)", size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'latestPriceMid', header: "Latest Price (mid)",size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'latestPriceHigh', header: "Latest Price (high)",size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'unitOfMeasure', header: "Unit of Measure",size: 90, minSize: 90, maxSize: 140 },
        { columnKey: 'latestAssessmentDate', header: "Latest Assessment Date",size: 90, minSize: 90, maxSize: 140 },
    ];
    
    
    const risiTableColumnMapping = {
        'commodityId': "Commodity ID",
        'commodityDescription': "Commodity Description",
        'indexId': "Index ID",
        'indexDescription': "Index Description",
        'risiLocation': "RISI Location",
        'currency': "Currency",
        'incoTerms': "INCO Terms",
        'assessmentFrequency': "Assessment Frequency",
        'latestPriceLow': "Latest Price (low)",
        'latestPriceMid': "Latest Price (mid)",
        'latestPriceHigh': "Latest Price (high)",
        'unitOfMeasure': "Unit of Measure",
        'latestAssessmentDate': "Latest Assessment Date"
      };
    
    const risiColumnsToInclude = [
        "Commodity ID",
        "Commodity Description",
        "Index ID",
        "Index Description",
        "RISI Location",
        "Currency",
        "INCO Terms",
        "Assessment Frequency",
        "Latest Price (low)",
        "Latest Price (mid)",
        "Latest Price (high)",
        "Unit of Measure",
        "Latest Assessment Date"
      ];


    /**** PRASANNA CHANGES ****/

    const risiLineChartRef = useRef();
    const risiModalRef = useRef();




 
	
	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
        setIsDataLoading(true)
		fetchUserInfo();
	}, []);
	const userData = useSelector((state) => state.getLandingPageReducer);
	const primaryDropdownData = useSelector((state) => state.getRISIDropdownReducer);
	const risiData = useSelector((state) => state.getRISIDetailReducer);
	const secondaryDropdownData = useSelector((state) => state.getRISISecondaryDropdownReducer);
    const risiTableData = risiData?.risiTableViewDtoList
    const risiLineChartData = risiData?.risiLineChartResponseDto
    const risiLineChartSeriesKeys = risiData?.risiLineChartIndexDto
    const seriesColors = ["#33ABDA", "#B05788", "#0078A7", "#8458CC", "#FFCC49"];
    
    const productCount = risiData?.risiData?.productCount;
    const lastUpdate = risiData?.risiData?.lastUpdate;
    const refreshFrequency = risiData?.risiData?.refreshFrequency;
    const appOwnersList = risiData?.owners
     
	
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {


            // dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            localStorage.setItem('firstRequest_risi', true);
            // 7 days NPS logic
            // const now = Date.now(); // current timestamp in milliseconds

            // const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            // const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }

            call7DaysNpsLogic(dispatch, userData)
            setCategoryL1Selected(DEFAULT_RISI_L1);
            setCategoryL0Selected(DEFAULT_RISI_L0);

            const Roles = getRoles(userData.details)
            const defaultRole = userData?.defaultRole;
            setRoleSelected([{ id: 1, displayText: defaultRole}]);
            const defaultRoleObject = Roles.filter(item => item.displayText === userData.defaultRole)

            
            const getUserInfoByRole = userData?.details?.filter(item => item.role === defaultRoleObject[0]?.displayText)?.[0]
            const sectors = getSectors(getUserInfoByRole?.roleDetail);
            let sectorsToInclude = sectors?.map(item => (item.displayText))
            setUserSectors(sectors);

            const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
            setUserBusinessUnits(BUs);

            setIsDataLoading(true)
            dispatch(FetchRISIDropdownAction());
        }
		
    }, [userData])

    /* istanbul ignore next */
    useEffect(() => {
        if (risiData && risiData.type === "SUCCESS_RISI_DETAIL_VIEW_ACTION") {
            
            setIsDataLoading(false);
        }
    }, [risiData])
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && primaryDropdownData && primaryDropdownData.type === "SUCCESS_RISI_DROPDOWN_ACTION") {
            const dropdownData = primaryDropdownData;
            
            const sectors = getSectorsForSupplierFilters(dropdownData?.sectorBu);
            localStorage.setItem('sectorsSelected_risi', JSON.stringify(sectors));
            setSectorSelected(sectors);
            setSectors(sectors);
            let sectorsToInclude = sectors?.map(item => (item.displayText ? item.displayText : item));

            setDropdownValues(dropdownData);

            const BUs = getBUsForSupplierFilters(dropdownData?.sectorBu, sectorsToInclude);
            localStorage.setItem('BUsSelected_risi', JSON.stringify(BUs));
            setBusinessUnitSelected(BUs);
            setBusinessUnits(BUs);
            setAllBUs(BUs);

            
            let capabilitySearchKey = "RISI";
            const maxDateForApps = [{
                ...primaryDropdownData?.maxDate,
                appName: "RISI"
            }];
            const maxDateObject = maxDateForApps
                ?.find(item => item.appName === capabilitySearchKey);

            let maxYearValue;
            let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
        
            if (maxYearMonth) {
                const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
                maxYearValue = parseInt(maxYearText, 10);
            }
            let yearsArray = [];
            for (let i = MIN_RISI_YEAR; i <= maxYearValue; i++) {
                yearsArray.push(i);
            }

            const allYears = getYears(yearsArray);
            const minYr = allYears[0]?.displayText;
            const minYear = Number(minYr);
            const maxYr = allYears[allYears.length - 1]?.displayText;
            const maxYear = Number(maxYr);

            
            const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
            setFromDates(fromDate);

            setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

            const date2 = new Date();
            const yearSelected = DEFAULT_FROM_DATE_YEAR // defaultYear;
            const date2Year = date2.getFullYear();

            const fromDateMonth = 'Jan';
            let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);
            
            const tempFromDate = fromDate.filter((item) => {
                return item.displayText === (fromDateMonth + ' ' + yearSelected);
            }) // Extracting year from maxDate
            
            let tempToDate = fromDate.filter((item) => {

                let currentLastMonth = Number(yearSelected) < objectYear ? "Dec " + yearSelected : maxYearMonth;

                return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
            });

            const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
            setToDates(toDateOptions);
            
            const defaultToDateOption = toDateOptions.filter(item=>item.displayText==DEFAULT_TO_DATE)
            if(defaultToDateOption && defaultToDateOption.length>0) {
                tempToDate = defaultToDateOption;
            } else {
                tempToDate = [toDateOptions[toDateOptions.length-1]];
            }

            const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
            if (index !== -1) {
                const tempFromDates = fromDate.slice(0, index + 1);
                setFromDates(tempFromDates);
            }
            setFromDateSelected(tempFromDate);
            setToDateSelected(tempToDate); 
            
            localStorage.setItem('fromDateSelected_risi', JSON.stringify(tempFromDate))
            localStorage.setItem('toDateSelected_risi', JSON.stringify(tempToDate))

            loadSecondaryDropdownData()

        }
    }, [primaryDropdownData])

    
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && secondaryDropdownData && secondaryDropdownData.type === "SUCCESS_RISI_SEC_DROPDOWN_ACTION") {
            const dropdownData = secondaryDropdownData;
            setSecondaryDropdownValues(dropdownData)
            
            setIndexMapping(transformIndexData(dropdownData?.commodity));
            const commodities = getCommoditiesForRISI(dropdownData?.commodity);
            setCommodities(commodities);
            const commoditiesToSelect= (getOverlappingOptionsV2(commodities,secondaryDropdownData?.defaultCommodity));
            setCommoditySelected(commoditiesToSelect);
            localStorage.setItem('commoditiesSelected_risi', JSON.stringify(commoditiesToSelect));

            let commoditiesToInclude = commoditiesToSelect?.map(item => (item.displayText));
            const indexes = getIndexesForRISI(dropdownData?.commodity,commoditiesToInclude);
            setIndexes(indexes);
            const indexesToSelect = (getOverlappingOptionsV2(indexes,secondaryDropdownData?.defaultIndex));
            setIndexSelected(indexesToSelect);
            localStorage.setItem('indexesSelected_risi', JSON.stringify(indexesToSelect));
            
            let indexesToInclude = indexesToSelect?.map(item => (item.displayText));
            const locations = getLocationsForRISI(dropdownData?.commodity, commoditiesToInclude, indexesToInclude);
            setLocations(locations);
            const locationsToSelect= (getOverlappingOptionsV2(locations,secondaryDropdownData?.defaultLocation));
            setLocationSelected(locationsToSelect);
            localStorage.setItem('locationsSelected_risi', JSON.stringify(locationsToSelect));

            const currenciesFromApi = Array.isArray(dropdownData?.currency)
                ? dropdownData.currency.map((item) => ({ id: item, displayText: item }))
                : [];
            setCurrencies(currenciesFromApi);

            const defaultCurrency = currenciesFromApi.length > 0 ? [currenciesFromApi[0]] : [];
            setCurrencySelected(defaultCurrency);
            localStorage.setItem('currenciesSelected_risi', JSON.stringify(defaultCurrency));
            loadKPIPageData();
        }
    }, [secondaryDropdownData])

    useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_RISI_DROPDOWN_ACTION', 
                payload: "RESET_RISI_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'RESET_RISI_SEC_DROPDOWN_ACTION', 
                payload: "RESET_RISI_SEC_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'RESET_RISI_DETAIL_VIEW_ACTION', 
                payload: "RESET_RISI_DETAIL_VIEW_ACTION" 
            });
        };
    }, []);

    

    /* istanbul ignore next */
    const loadSecondaryDropdownData = ()=> {
        const sectorData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));  
        const buData = JSON.parse(localStorage.getItem("BUsSelected_risi"));
        const selectedRole = roleSelected?.[0]?.displayText || "";
        const firstReq = localStorage.getItem("firstRequest_risi");
        const requestObject = {
            role: selectedRole,
            sector: sectorData?.map((item) => item.displayText ? item.displayText : item),
            bu: buData?.map((item) => item.displayText ? item.displayText : item),
            userSector: userSectors?.map((item) => item.displayText ? item.displayText : item),
            userBu: userBusinessUnits?.map((item) => item.displayText ? item.displayText : item),
            firstRequest: (firstReq==="true"?true:false)
        };
        setIsDataLoading(true);
        dispatch(FetchRISISecondaryDropdownAction(requestObject));
        setFirstRequest(false);
        localStorage.setItem('firstRequest_risi', false);

    }    
    /* istanbul ignore next */
    const loadKPIPageData = ()=> {

        const sectorsData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));  
        const BUsData = JSON.parse(localStorage.getItem("BUsSelected_risi"));
        const categoryL0Data = categoryL0Selected;
        const categoryL1Data = categoryL1Selected;
        const fromDateData = JSON.parse(localStorage.getItem("fromDateSelected_risi")); 
        const toDateData = JSON.parse(localStorage.getItem("toDateSelected_risi")); 

        const commodityData = JSON.parse(localStorage.getItem("commoditiesSelected_risi"));  
        const indexData = JSON.parse(localStorage.getItem("indexesSelected_risi")); 
        const locationData = JSON.parse(localStorage.getItem("locationsSelected_risi")); 
        const currencyData = JSON.parse(localStorage.getItem("currenciesSelected_risi")); 

        if(sectorsData.length>0 &&
            BUsData.length>0 &&
            categoryL0Data.length>0 &&
            categoryL1Data.length>0 &&
            fromDateData.length>0 &&
            toDateData.length>0 &&
            commodityData.length>0 &&
            indexData.length>0 &&
            locationData.length>0 &&
            currencyData.length>0
        ) {
            const selectedCurrency = Array.isArray(currencyData)
                ? (currencyData?.[0]?.displayText ? currencyData[0].displayText : currencyData?.[0])
                : (currencyData?.displayText ? currencyData.displayText : currencyData);

            const requestObject = {
                fromDate: fromDateData?.[0]?.value || '',
                toDate: toDateData?.[0]?.value || '',
                sector: sectorsData?.map((item) => item.displayText ? item.displayText : item),
                bu: BUsData?.map((item) => item.displayText ? item.displayText : item),
                l0: categoryL0Data?.map((item) => item.displayText),
                l1: categoryL1Data?.map((item) => item.displayText),
                commodity: commodityData?.map((item) => item.displayText),
                index: indexData?.map((item) => item.displayText),
                location: locationData?.map((item) => item.displayText),
                currency: selectedCurrency || '',
            };
            
            setIsDataLoading(true);
            dispatch(FetchRISIDetailAction(requestObject));

        } else {
            message.warning("Please select required filters");
        }
        
    }

    
    /* istanbul ignore next */
    const onCommodityChange = (val) => {
        if(val && val.length>MAX_OPTIONS_SELECTION_ALLOWED) {
            message.warning("Please select at max "+MAX_OPTIONS_SELECTION_ALLOWED+" commodities")
            const commoditiesSelected = JSON.parse(localStorage.getItem("commoditiesSelected_risi"))
            setCommoditySelected(commoditiesSelected)
            return;
        }
        if (val && val.length > 0) {
            const previousCommoditiesSelected = JSON.parse(localStorage.getItem("commoditiesSelected_risi"));
            const newCommoditiesSelected = val;
            const previousIndexes = JSON.parse(localStorage.getItem("indexesSelected_risi"));
            if(previousCommoditiesSelected.length>newCommoditiesSelected.length) { 
                // Commodity Option is Deselected, so respective Index, Location will be deselected
                const removedCommodityOption = getAdditionalDisplayTexts(previousCommoditiesSelected,newCommoditiesSelected);
                const indexOptionsTobeRemoved = indexMapping?.[removedCommodityOption?.[0]]
                const previousIndexesStrList = previousIndexes?.map(item => (item.displayText));

                let commoditiesToInclude = newCommoditiesSelected?.map(item => (item.displayText));
                const indexes = getIndexesForRISI(secondaryDropdownValues?.commodity,commoditiesToInclude);
                setIndexes(indexes);
                const indexesToSelect = (getOverlappingOptionsV2(indexes,previousIndexesStrList));
                setIndexSelected(indexesToSelect);
                localStorage.setItem('indexesSelected_risi', JSON.stringify(indexesToSelect));

                
                let indexesToInclude = indexesToSelect?.map(item => (item.displayText));
                const locations = getLocationsForRISI(secondaryDropdownValues?.commodity, commoditiesToInclude, indexesToInclude);
                setLocations(locations);
                setLocationSelected(locations);
                localStorage.setItem('locationsSelected_risi', JSON.stringify(locations));
                
                localStorage.setItem('commoditiesSelected_risi', JSON.stringify(val));
                setCommoditySelected(val);
                loadKPIPageData();

            } else {
                // New Commodity Option is selected, so respective Index top index will be selected
                const addedCommodityOption = getAdditionalDisplayTexts(newCommoditiesSelected,previousCommoditiesSelected)
                const allIndexOptionsIntheCommodity = indexMapping?.[addedCommodityOption?.[0]] // getting all the indices for newly selected 
                const previousIndexesStrList = previousIndexes?.map(item => (item.displayText));
                
                if(previousIndexes.length>=5) {
                    message.warning("At max "+MAX_OPTIONS_SELECTION_ALLOWED+" indices can be selected.")
                    const commoditiesSelected = JSON.parse(localStorage.getItem("commoditiesSelected_risi"))
                    setCommoditySelected(commoditiesSelected)
                    return;
                }
                const newIndexOptionsAvailableToAdd = MAX_OPTIONS_SELECTION_ALLOWED - previousIndexes.length;
                // const newIndexOptionsAvailableToAdd = 1;
                const newIndexOptionsToSelect = getFirstUniqueItems(allIndexOptionsIntheCommodity,previousIndexesStrList,newIndexOptionsAvailableToAdd)
                
                let commoditiesToInclude = newCommoditiesSelected?.map(item => (item.displayText));
                const indexes = getIndexesForRISI(secondaryDropdownValues?.commodity,commoditiesToInclude);
                setIndexes(indexes);
                const merge = (a, b) => [...new Set([...a, ...b])];
                const mergedIndexList = merge(previousIndexesStrList,newIndexOptionsToSelect)
                const indexesToSelect = (getOverlappingOptionsV2(indexes,mergedIndexList));
                setIndexSelected(indexesToSelect);
                localStorage.setItem('indexesSelected_risi', JSON.stringify(indexesToSelect));

                let indexesToInclude = indexesToSelect?.map(item => (item.displayText));
                const locations = getLocationsForRISI(secondaryDropdownValues?.commodity, commoditiesToInclude, indexesToInclude);
                setLocations(locations);
                setLocationSelected(locations);
                localStorage.setItem('locationsSelected_risi', JSON.stringify(locations));
                
                localStorage.setItem('commoditiesSelected_risi', JSON.stringify(val));
                setCommoditySelected(val);
                loadKPIPageData();
            }
            

           // console.log(previousCommoditiesSelected,newCommoditiesSelected)

        }
        else {
            
            if (val && val.length === 0) {
                setCommoditySelected([]);
                localStorage.setItem('commoditiesSelected_risi', JSON.stringify([]));
                setIndexSelected([]);
                localStorage.setItem('indexesSelected_risi', JSON.stringify([]));
                setLocationSelected([]);
                localStorage.setItem('locationsSelected_risi', JSON.stringify([]));
                message.warning("At least one commodity is required")
            }
        }
    }
    /* istanbul ignore next */
    const onIndexChange = (val) => {
        if(val && val.length>MAX_OPTIONS_SELECTION_ALLOWED) {
            message.warning("Please select at max "+MAX_OPTIONS_SELECTION_ALLOWED+" indices")
            const indexesSelected = JSON.parse(localStorage.getItem("indexesSelected_risi"))
            setIndexSelected(indexesSelected)
            return;
        }
        if (val && val.length > 0) {
            
            setIndexSelected(val);
            localStorage.setItem('indexesSelected_risi', JSON.stringify(val));

            const commoditiesSelected = JSON.parse(localStorage.getItem("commoditiesSelected_risi"))
            let commoditiesToInclude = commoditiesSelected?.map(item => (item.displayText));
            let indexesToInclude = val?.map(item => (item.displayText));
            const locations = getLocationsForRISI(secondaryDropdownValues?.commodity, commoditiesToInclude, indexesToInclude);
            setLocations(locations);
            setLocationSelected(locations);
            localStorage.setItem('locationsSelected_risi', JSON.stringify(locations));
            loadKPIPageData();
        }
        else {
            
            if (val && val.length === 0) {
                setIndexSelected([]);
                localStorage.setItem('indexesSelected_risi', JSON.stringify([]));
                setLocationSelected([]);
                localStorage.setItem('locationsSelected_risi', JSON.stringify([]));
                message.warning("At least one index is required")
            }
        }
    } 
    /* istanbul ignore next */
    const onLocationChange = (val) => {
        if(val && val.length>MAX_OPTIONS_SELECTION_ALLOWED) {
            message.warning("Please select at max "+MAX_OPTIONS_SELECTION_ALLOWED+" locations")
            const locationsSelected = JSON.parse(localStorage.getItem("locationsSelected_risi"))
            setLocationSelected(locationsSelected)
            return;
        }
        if (val && val.length > 0) {
            setLocationSelected(val)
            localStorage.setItem("locationsSelected_risi", JSON.stringify(val))
            loadKPIPageData();
        }
        else {
            
            if (val && val.length === 0) {
                setLocationSelected([]);
                localStorage.setItem('locationsSelected_risi', JSON.stringify([]));
                message.warning("At least one location is required")
            }
        }
    }

    /* istanbul ignore next */
    const onCurrencyChange = (val) => {
        if (val && val.length > 0) {
            setCurrencySelected(val)
            localStorage.setItem("currenciesSelected_risi", JSON.stringify(val))
            loadKPIPageData();
        } else if (val && val.length === 0) {
            setCurrencySelected([])
            localStorage.setItem("currenciesSelected_risi", JSON.stringify([]))
            message.warning("At least one currency is required")
        }
    }

    /* istanbul ignore next */
    const onSectorChange = (val) => {
        if (val && val.length > 0) {
            
            let sectorsToInclude = val?.map(item => (item.displayText ? item.displayText : item))
            const BUs = getBUsForSupplierFilters(dropdownValues?.sectorBu, sectorsToInclude);
            setSectorSelected(val)
            localStorage.setItem("sectorsSelected_risi", JSON.stringify(val))

            localStorage.setItem("BUsSelected_risi", JSON.stringify(BUs))
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            loadSecondaryDropdownData();
        } else {
            
            if (val && val.length === 0) {
                message.warning("At least one sector is required")
                setBusinessUnitSelected([])
                setSectorSelected([])
                localStorage.setItem("BUsSelected_risi", JSON.stringify([]))
                localStorage.setItem("sectorsSelected_risi", JSON.stringify([]))
            }

        }
    }
    /* istanbul ignore next */
    const onBusinessUnitChange = (val) => {
        if (val && val.length > 0) {
            if (sectorSelected.length > 0) {
                setBusinessUnitSelected(val)
                localStorage.setItem("BUsSelected_risi", JSON.stringify(val))
                loadSecondaryDropdownData();
                
            } else {
                message.warning("Please select at least one sector")
            }
        } else {
            if (val && val.length === 0) {
                message.warning("At least one business unit / market is required")
                localStorage.setItem("BUSeleceted_suppliers", JSON.stringify([]))
                setBusinessUnitSelected([])
            }
        }
    }
    /* istanbul ignore next */
    const onFromDateChange = (val) => {
        if (val && val.length > 0) {
            setFromDateSelected(val)
            localStorage.setItem('fromDateSelected_risi', JSON.stringify(val))
            const toDateOptions = getToDateOptions(val[0]['displayText']);

            const maxDateForApps = [{
                ...primaryDropdownData?.maxDate,
                appName: "RISI"
            }];
            let capabilitySearchKey = "RISI";
            const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);
            const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]['displayText'], maxDateObject);
            setToDates(toDateOptions1);

            let tempY = val[0]['displayText']?.split(" ")?.[1]
            const date1 = new Date(val[0]['displayText']);
            const date2 = new Date(toDateSelected?.[0]?.['displayText']);
            const date2Year = date2?.getFullYear();
            const toDateMonth = months[date2?.getMonth()];;

            const tempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === ('Dec ' + tempY);
            })

            const customTempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === (`${toDateMonth} ` + date2Year);
            })
            changeToDateOptions(val[0])

            if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
                if (date1 <= date2) {
                    setToDateSelected(customTempToDate); 
                    localStorage.setItem('toDateSelected_risi', JSON.stringify(customTempToDate))
                    loadKPIPageData();
                } else {
                    setToDateSelected(tempToDate);
                    localStorage.setItem('toDateSelected_risi', JSON.stringify(tempToDate))
                    loadKPIPageData();
                }
            } else {
                loadKPIPageData();
            }
        } else {
            message.warning("From Date is not selected")

        }
    }
    /* istanbul ignore next */
    const onToDateChange = (val) => {
        if (val && val.length > 0) {
            setToDateSelected(val)
            localStorage.setItem('toDateSelected_risi', JSON.stringify(val))
            changeFromDateOptions(val[0]);
            loadKPIPageData();
        } else {
            message.warning("To Date is not selected")

        }
    }

    /* istanbul ignore next */
    const changeFromDateOptions = (toDateMonthSelected) => {
        const filteredMonths = changeFromDateOptionsUtil(toDateMonthSelected, entireMonthList)
        setFromDates(filteredMonths)
    }

    /* istanbul ignore next */
    const changeToDateOptions = (fromDateMonthSelected) => {
        const filteredMonths = changeToDateOptionsUtil(fromDateMonthSelected, entireMonthList)
        setToDates(filteredMonths);
    };
    /* istanbul ignore next */
    const onFiltersReset = () => {
        
        setSectorSelected(sectors);
        localStorage.setItem('sectorsSelected_risi', JSON.stringify(sectors));
        setBusinessUnitSelected(allBUs);
        localStorage.setItem('BUsSelected_risi', JSON.stringify(allBUs));
        
        setFirstRequest(true);
        localStorage.setItem('firstRequest_risi', true);


        const maxDateForApps = [{
            ...primaryDropdownData?.maxDate,
            appName: "RISI"
        }];
        let capabilitySearchKey = "RISI";
        const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

        let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
        let maxYearValue;
    
        if (maxYearMonth) {
            const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
            maxYearValue = parseInt(maxYearText, 10);
        }
        let yearsArray = [];
        for (let i = MIN_RISI_YEAR; i <= maxYearValue; i++) {
            yearsArray.push(i);
        }

        const allYears = getYears(yearsArray);
        const maxYr = allYears[allYears.length - 1]?.displayText;
        const minYr = allYears[0]?.displayText;

        const minYear = Number(minYr);
        const maxYear = Number(maxYr);

        setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));
        
        const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
        setFromDates(fromDate);

        const yearSelected = DEFAULT_FROM_DATE_YEAR // defaultYear;

        const date2 = new Date();
        const date2Year = date2.getFullYear();

        const fromDateMonth = 'Jan';
        
        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })
        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]); // Extracting year from maxDate
        
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setToDates(toDateOptions);
            
        const defaultToDateOption = toDateOptions.filter(item=>item.displayText==DEFAULT_TO_DATE)
        if(defaultToDateOption && defaultToDateOption.length>0) {
            tempToDate = defaultToDateOption;
        } else {
            tempToDate = [toDateOptions[toDateOptions.length-1]]
        }

        setFromDateSelected(tempFromDate);
        
        localStorage.setItem('fromDateSelected_risi', JSON.stringify(tempFromDate))

        setToDateSelected(tempToDate); 
        localStorage.setItem('toDateSelected_risi', JSON.stringify(tempToDate))
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }

        loadSecondaryDropdownData()

    }







    

    /**** PRASANNA CHANGES FUNCTIONS ****/
    useEffect(()=>{
        // const getCombinedData = (switchIndex) => {
        //     let level = switchIndex == 0 ? 'low' : switchIndex == 1 ? 'mid' : 'high';
 
        //     const { actual = [], forecast = [] } = risiLineChartData?.[level] || {};
        //     return [...actual, ...forecast];
        // };


        

        const getCombinedData = (switchIndex) => {
            const level =
                switchIndex == 0 ? "low" : switchIndex == 1 ? "mid" : "high";

            const { actual = [], forecast = [] } =
                risiLineChartData?.[level] || {};

            if (!actual.length) return forecast;
            if (!forecast.length) return actual;

            const lastThreeActuals = actual.slice(-3);
            const firstThreeForecasts = forecast.slice(0, 3);

            const keysArray = Object.keys(firstThreeForecasts[0] || {}).filter(
                key => key !== "yearMonth" && key !== "assessmentDate"
            );

            setFirstForecastKeysToBeMergedActualLAst(keysArray);

            const forecastMap = new Map(
                firstThreeForecasts.map(item => [item.yearMonth, item])
            );

            let isFirstSet = false;

            const mergedActuals = actual.map((act) => {
            const forecastMatch = forecastMap.get(act.yearMonth);

            if (forecastMatch) {

                if (!isFirstSet) {
                setFirstForecastYearMonth(forecastMatch.yearMonth);
                isFirstSet = true;
                }

                return {
                ...act,
                ...forecastMatch,
                isForecastLabel: true,
                };
            }

            return act;
            });

            const mergedMonths = new Set(lastThreeActuals.map(a => a.yearMonth));

            const remainingForecasts = forecast.filter(
                f => !mergedMonths.has(f.yearMonth)
            );
            return [...mergedActuals, ...remainingForecasts];
        };
        
        // function getForecastStartMonth(data) {
        //     const level = switcherIndex === 0 ? 'low' : switcherIndex === 1 ? 'mid' : 'high';
        //     const actual = data?.[level]?.actual;
        //     const forecast = data?.[level]?.forecast;
        //     return actual?.[actual.length - 1]?.yearMonth || forecast?.[0]?.yearMonth || null;
        // }

        function getForecastStartMonth(data) {
            const level =
                switcherIndex === 0 ? "low" :
                switcherIndex === 1 ? "mid" : "high";

            const actual = data?.[level]?.actual || [];
            const forecast = data?.[level]?.forecast || [];
            
            setLineChartActualData(actual)
            if (!actual.length && !forecast.length) return null;

            const lastThreeActuals = actual.slice(-3);
            const firstThreeForecasts = forecast.slice(0, 3);

            const forecastMonths = new Set(
                firstThreeForecasts.map(f => f.yearMonth)
            );

            const firstMerged = lastThreeActuals.find(a =>
                forecastMonths.has(a.yearMonth)
            );

            if (firstMerged) return firstMerged.yearMonth;
            
            
            return forecast?.[0]?.yearMonth || null;
        }
        

        const forecastStart = getForecastStartMonth(risiLineChartData);
        const modifiedRisiLineChartData = getCombinedData(switcherIndex);

          const risiSeriesLineChartVal= risiLineChartSeriesKeys?.map((item, index) => ({
            ...item,
            color: seriesColors[index % seriesColors.length]  // safe even if more items than colors
          }));

            const risiLineChartLegendsVal = risiLineChartSeriesKeys?.map((item, index) => ({
                name: item.key,
                color: seriesColors[index % seriesColors.length]  // safe even if more items than colors
            }));
        
            setRisiLineChartLegends(risiLineChartLegendsVal)
            setRisiSeriesLineChartIndex(risiSeriesLineChartVal)
            setChartData(modifiedRisiLineChartData)
            setForecastStartVal(forecastStart)
            
    }, [switcherIndex, risiLineChartData, risiLineChartSeriesKeys])

    /* istanbul ignore next */
    const loadKPIData = ()=> {

    }


   






    /**** PRASANNA CHANGES ****/

    const { showToast } = useToast();

    /* istanbul ignore next */
    const checkPDFDownloaded = () => {}

    /* istanbul ignore next */
	if(authState?.isAuthenticated){
		return(
			
                <>
                    

                    <div ref={risiModalRef}>
                        <Breadcrumb
                            breadcrumbs={[
                                {
                                label: 'Home',
                                onClick: function aFe(){navigate("/overview")}
                                },
                                // {
                                // label: 'Overview',
                                // onClick: function aFe(){navigate("/overview")}
                                // },
                                {
                                label: 'Market Intelligence Hub',
                                // onClick: function aFe(){navigate("/overview/commodity")}
                                onClick: function aFe(){navigate("/overview/mi")}
                                },
                                {
                                label: 'Packaging',
                                // onClick: function aFe(){navigate("/overview/commodity/packaging-indices")}
                                onClick: function aFe(){navigate("/overview/mi/packaging")}
                                },
                                {
                                label: 'Corrugated',
                                onClick: function aFe(){}
                                }
                            ]}
                            className="ph-breadcrumb"
                            style={{padding: '30px 30px 30px 0px', width: "100%"}}
                            homeIcon={{
                                icon: 'track_changes'
                            }}
                        />

                        <div>
                            <div className="commodity-detail-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                                <span>Corrugated</span> 
                                {/* <span>
                                    <DropdownWithIcons modalRef={risiModalRef} isModal={true} kpiName={"RISI_Modal"} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>        */}
                                    {
                                        isDataLoading ? (
                                            <></>
                                        ) :                    
                                        <>
                                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                <CustomButtons isModal={true} appList={risiData?.apps} />
                                                <span style={{float: 'right', position: 'relative', right: '1rem', bottom: '0.3rem'}}>
                                                <DropdownWithIcons modalRef={risiModalRef} isModal={true} kpiName={"RISI_Modal"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                </span>
                                            </span>


                                        
                                        </>
                                    }
                            </div>
                            <div style={{width: '100%'}}>
                                <div className="risi-title-info" style={{fontSize: "13px", width: '100%'}}>
                                <span style={{fontWeight:"700", fontSize: "13px"}}>SOURCES:</span> FASTMARKETS (RISI)
                                </div>
                                <div className="risi-title-info" style={{fontSize: "13px", width: '100%'}}>
                                    <span style={{fontWeight:"700", fontSize: "13px"}}>CAPABILITIES:</span> Commodity Prices, Forecasts
                                </div>
                                <div className="risi-title-info" style={{fontSize: "13px", width: '100%', marginTop: "7px"}}>
                                    Total number of Price Indices available: <span style={{fontWeight:"700", fontSize: "13px"}}>{productCount || 0}</span>
                                </div>
                            </div>
                            {/* <div className="risi-title-info">
                                {userInfo?.FirstName}, the total number of Indices (Price & Forecast) for Packaging (Forest Products) is <span style={{fontWeight: 700}}>{productCount || 0}</span>.
                            </div> */}
                                                        
                                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", marginTop:"10px", display: "flex", fontSize: "14px",wordWrap:"break-word", whiteSpace: "normal", maxWidth: "858px" }}>{"This application allows access to all data and filters regardless of your role. To see RISI price movement/forecasts, please select the commodity, type of index, and location from the filters below."}</div> 
                           

                            {(lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(refreshFrequency)}</div>}
                            
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"24px" }}>
                                <Col flex="1">
                                    <SingleSelectDropdown placeholder="View" className='buy-con-dropdown-modal' label="View" childList={roleSelected} selectedValue={roleSelected} setSelectedValue={{}} disabled={true} />
                                </Col>
                                <Col flex="1">
                                    <MultiSelectDropdown placeholder="Sectors" className='buy-con-dropdown-modal' label="Sector" childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange} />
                                </Col>
                                <Col flex="1">
                                    <MultiSelectDropdown placeholder="BUs" className='buy-con-dropdown-modal' label="Business Unit / Market" childList={businessUnits} selectedValue={businessUnitSelected} setSelectedValue={onBusinessUnitChange} />
                                </Col>
                                <Col flex="1">
                                    <SingleSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' 
                                    label="Category L0" 
                                    disabled={true} 
                                    setSelectedValue={{}} 
                                    selectedValue={categoryL0Selected} 
                                    childList={categoryL0Selected} />
                                </Col>
                                <Col flex="1">
                                    <SingleSelectDropdown placeholder={"Categories L1"} 
                                    disabled={true}
                                    setSelectedValue={{}}
                                    label={"Category L1"} 
                                    className='buy-con-dropdown-modal' 
                                    selectedValue={categoryL1Selected} 
                                    childList={categoryL1Selected}   />
                                </Col>
                                <Col flex="1">
                                    <SingleSelectDropdown
                                        setSelectedValue={onFromDateChange}
                                        selectedValue={fromDateSelected}
                                        childList={fromDates}
                                        label={"From Date"}
                                        className='buy-con-dropdown-modal'
                                    />
                                </Col>
                                <Col flex="1">
                                        <SingleSelectDropdown className='buy-con-dropdown-modal' 
                                            label="To Date" 
                                            setSelectedValue={onToDateChange}
                                            selectedValue={toDateSelected} 
                                            childList={toDates} 
                                            />
                                </Col>
                            </Row>

                            {/* <div className="commodity_page_header" style={{ width: "100%", marginTop:"12px", alignItems: "center", textAlign: "left", display: "flex", justifyContent:"space-between", fontSize: '16px' }}>
                                <span>To see RISI price movement/forecasts, please select the commodity, type of index, and location from the filters below.</span>
                            </div> */}
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}>
                                {/* <div style={{ width: "100%", textAlign: "left", display: "flex", justifyContent:"space-between" }}> */}
                                                
                                    {/* <Tooltip text={"Select up to 5 Indices"} direction={"bottom"} style={{ marginTop: 10 }}>
                                        <Icon alt="" icon="info" size="large" style={{ marginTop: "1.3rem" , marginRight:"1rem"}} />
                                    </Tooltip>  */}
                                    {/* <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}> */}
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <MultiSelectDropdown placeholder="Commodity" className='buy-con-dropdown-modal risi-dropdown' label="Commodity" childList={commodities} selectedValue={commoditySelected} setSelectedValue={onCommodityChange}/>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <MultiSelectDropdown placeholder="Index" className='buy-con-dropdown-modal risi-dropdown' label="Index (Select up to 5)" childList={indexes} selectedValue={indexSelected} setSelectedValue={onIndexChange} />
                                        </Col>
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <MultiSelectDropdown placeholder="RISI Location" className='buy-con-dropdown-modal risi-dropdown' label="RISI Location" childList={locations} selectedValue={locationSelected} setSelectedValue={onLocationChange} />
                                        </Col>
                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                            <SingleSelectDropdown placeholder="Currency" className='buy-con-dropdown-modal risi-dropdown' label="Currency" childList={currencies} selectedValue={currencySelected} setSelectedValue={onCurrencyChange} />
                                        </Col>
                                    {/* </Row> */}
                                {/* </div> */}
                            </Row>
            
                            <Row justify="end">
                                    <button className="reset-button" onClick={onFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem', marginBottom: "24px" }}>
                                        <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                        <span>Reset Filters</span>
                                    </button>
                            </Row>
                            
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Card style={{ height: '100%' }}>
                                        
                                        
                                    {
                                        (isDataLoading || risiData?.type !== "SUCCESS_RISI_DETAIL_VIEW_ACTION") ? 
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                                        </div>
                                        :
                                        <>
                                        
                                        {/* PRSANNA CHANGES */}
                                        {/* <div> */}
                                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <div ref={risiLineChartRef} style={{width: '100%', height: '100%'}}>
                                                          
                                                            {
                                                                chartData && chartData?.length > 0 ?
                                                                    // <div className="ph-table-wrapper">
                                                                    <div >
                                                                        <div className="commodity_page_header" style={{ width: "100%", alignItems: "center", textAlign: "left", display: "flex", justifyContent:"space-between", fontSize: '16px' }}>
                                                                            <span>Commodity Index Price Movement and Forecast</span>
                                                                            <span>
                                                                                <DropdownWithIcons modalRef={risiLineChartRef} kpiName={"Commodity Index Price Movement and Forecast"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                            </span>
                                                                        </div>
                                                                        <div style={{ width: "100%", textAlign: "right", display: "flex", justifyContent:"space-between" }}>
                                                                        <div>
                                                                            <img src={ActualLegendRISI} alt='img' style={{marginRight: '1rem'}}/>
                                                                                <span style={{marginRight: '0.25rem', position: 'relative', top: '3px'}}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                        <line
                                                                                        x1="0"
                                                                                        y1="6"
                                                                                        x2="12"
                                                                                        y2="6"
                                                                                        stroke={'#616161'}
                                                                                        strokeWidth="2"
                                                                                        strokeLinecap="round"
                                                                                        strokeDasharray="5 0"  // bigger dash pattern
                                                                                        />
                                                                                    </svg>
                                                                                </span>
                                                                                <span style={{marginRight: '0.25rem', position: 'relative', top: '3px'}}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                        <line
                                                                                        x1="0"
                                                                                        y1="6"
                                                                                        x2="18"
                                                                                        y2="6"
                                                                                        stroke={'#616161'}
                                                                                        strokeWidth="2"
                                                                                        strokeLinecap="round"
                                                                                        strokeDasharray="5 0"  // bigger dash pattern
                                                                                        />
                                                                                    </svg>
                                                                                </span>
                                                                                <span style={{color: '#616161', position: 'relative', top: '2px'}}>Forecast</span>
                                                                            
                                                                        </div>
                                                                            <div style={{float:"right", position: 'relative', right: '1.25rem'}}>
                                                                                <Switcher
                                                                                    className=""
                                                                                    items={[
                                                                                        {
                                                                                        label: 'Low',
                                                                                        leadingIcon: 'edit',
                                                                                        showLeadingIcon: false
                                                                                        },
                                                                                        {
                                                                                        label: 'Mid',
                                                                                        leadingIcon: 'edit',
                                                                                        showLeadingIcon: false
                                                                                        },
                                                                                        {
                                                                                        label: 'High',
                                                                                        leadingIcon: 'edit',
                                                                                        showLeadingIcon: false
                                                                                        },
                                                                                    ]}
                                                                                    selectedItemIndex={0}
                                                                                    onUpdate= {(val) => setSwitcherIndex(val)}
                                                                                    style={{}}
                                                                                />
                                                                                <span className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                                <InfoIcon  style={{position: 'relative', top: '0.5rem', left: '0.5rem'}} direction={"left"}
                                                                                                            text={`RANGE
                                                                                                            Low: Lower bound of the price range. Example: 38
                                                                                                            Mid: Midpoint or average of the price range. Example: 38.5
                                                                                                            High: Upper bound of the price range. Example: 39`} />
                                                                                </span>
                                                                            </div> 
                                                                            
                                                                        </div>
                                                                        <RisiLineChart rawData={chartData} forecastStartLabel={forecastStartVal} risiSeriesLineChartIndex={risiSeriesLineChartIndex} firstForecastYearMonth={firstForecastYearMonth} firstForecastKeysToBeMergedActualLAst={firstForecastKeysToBeMergedActualLAst} lineChartactualData={lineChartactualData}/>
                                                                        <LegendList legends={risiLineChartLegends} />
                                                                    </div>
                                                                    : <NoData />
                                                            }
                                                            <br/>
                                                        </div>
                                                    </Col>
                                            </Row>
                                            <Row gutter={[10, 10]} style={{ width: '100%' }}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            {/* <Card> */}
                                                            {
                                                                risiTableData && risiTableData?.length > 0 ?
                                                                    <div className="ph-table-wrapper">
                                                                    {/* <div > */}
                                                                        <CommonTable className="risi-table" data={risiTableData} columns={risiTableColumns} tableHeader={"Commodity Indices Details"} enableSorting={true} columnsToInclude={risiColumnsToInclude} columnMapping={risiTableColumnMapping} tableName={'Commodity Indices Details'}/>
                                                                    </div>
                                                                    : <><div style={{ width: '100%', textAlign: 'left', fontSize: 18, fontWeight: 700, color: '#3a3a3a' }}>Commodity Indices Details</div><NoData /></>
                                                            }
                                                            {/* </Card> */}
                                                        </Col>

                                            </Row>
                                        {/* </div> */}

                                        </>
                                    }
                                    </Card>
                                </Col>
                            </Row>
                            <br/>
                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                appOwnersList?.length>0 &&    
                                <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                    <React.Fragment key={index}>
                                        <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                        {index < appOwnersList.length - 1 && ', '}
                                    </React.Fragment>
                                ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </div>
                        
                    </div>
                </>
		)
	}
}

export default RISIScreen;